export default "__VITE_ASSET__LQsIIzVD__"